const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "neutral",
  "unknown",
  "registered",
  "inProgress",
  "waitingForVerification",
  "workDone",
  "readyForInvoicing",
  "invoiced",
  "finished",
  "deleted",
  "cancelled"
] as const

const size = [
  "3xs",
  "2xs",
  "xs",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl",
  "3xl"
] as const

export default {
  "slots": {
    "root": "inline-flex items-center justify-center shrink-0 select-none rounded-full align-middle",
    "image": "h-full w-full rounded-[inherit] object-cover",
    "fallback": "font-medium truncate",
    "icon": "shrink-0"
  },
  "variants": {
    "color": {
      "primary": {
        "root": "bg-primary/10",
        "fallback": "text-primary",
        "icon": "text-primary"
      },
      "secondary": {
        "root": "bg-secondary/10",
        "fallback": "text-secondary",
        "icon": "text-secondary"
      },
      "success": {
        "root": "bg-success/10",
        "fallback": "text-success",
        "icon": "text-success"
      },
      "info": {
        "root": "bg-info/10",
        "fallback": "text-info",
        "icon": "text-info"
      },
      "warning": {
        "root": "bg-warning/10",
        "fallback": "text-warning",
        "icon": "text-warning"
      },
      "error": {
        "root": "bg-error/10",
        "fallback": "text-error",
        "icon": "text-error"
      },
      "neutral": {
        "root": "bg-elevated",
        "fallback": "text-muted",
        "icon": "text-muted"
      },
      "unknown": {
        "root": "bg-unknown/10",
        "fallback": "text-unknown",
        "icon": "text-unknown"
      },
      "registered": {
        "root": "bg-registered/10",
        "fallback": "text-registered",
        "icon": "text-registered"
      },
      "inProgress": {
        "root": "bg-inProgress/10",
        "fallback": "text-inProgress",
        "icon": "text-inProgress"
      },
      "waitingForVerification": {
        "root": "bg-waitingForVerification/10",
        "fallback": "text-waitingForVerification",
        "icon": "text-waitingForVerification"
      },
      "workDone": {
        "root": "bg-workDone/10",
        "fallback": "text-workDone",
        "icon": "text-workDone"
      },
      "readyForInvoicing": {
        "root": "bg-readyForInvoicing/10",
        "fallback": "text-readyForInvoicing",
        "icon": "text-readyForInvoicing"
      },
      "invoiced": {
        "root": "bg-invoiced/10",
        "fallback": "text-invoiced",
        "icon": "text-invoiced"
      },
      "finished": {
        "root": "bg-finished/10",
        "fallback": "text-finished",
        "icon": "text-finished"
      },
      "deleted": {
        "root": "bg-deleted/10",
        "fallback": "text-deleted",
        "icon": "text-deleted"
      },
      "cancelled": {
        "root": "bg-cancelled/10",
        "fallback": "text-cancelled",
        "icon": "text-cancelled"
      }
    },
    "size": {
      "3xs": {
        "root": "size-4 text-[8px]"
      },
      "2xs": {
        "root": "size-5 text-[10px]"
      },
      "xs": {
        "root": "size-6 text-xs"
      },
      "sm": {
        "root": "size-7 text-sm"
      },
      "md": {
        "root": "size-8 text-base"
      },
      "lg": {
        "root": "size-9 text-lg"
      },
      "xl": {
        "root": "size-10 text-xl"
      },
      "2xl": {
        "root": "size-11 text-[22px]"
      },
      "3xl": {
        "root": "size-12 text-2xl"
      }
    }
  },
  "defaultVariants": {
    "size": "md" as typeof size[number],
    "color": "neutral" as typeof color[number]
  }
}